module.exports = __webpack_public_path__ + "img/1f_r_inamatsu@2x.fdd49a9d.jpg";